import { createApp } from 'vue'
import { Quasar, Notify } from 'quasar'
import { createI18n } from 'vue-i18n'

import '@quasar/extras/material-icons/material-icons.css'
import 'quasar/src/css/index.sass'
import './style.css'

import App from './App.vue'
import en from './i18n/en.json'
import ar from './i18n/ar.json'

const savedLocale = typeof localStorage !== 'undefined'
  ? (localStorage.getItem('locale') as 'en' | 'ar' | null)
  : null
const initialLocale = savedLocale === 'ar' || savedLocale === 'en' ? savedLocale : 'en'

const i18n = createI18n({
  legacy: false,
  locale: initialLocale,
  fallbackLocale: 'en',
  messages: { en, ar }
})

const app = createApp(App)

app.use(Quasar, {
  plugins: { Notify }
})

app.use(i18n)
app.mount('#app')